var map = {
	"./chatwidget/ChatWidgetPage.js": [
		25074,
		74
	],
	"./documentagent/DocumentAgentPage.js": [
		1375,
		375
	],
	"./labourlawadvisor/LabourLawAdvisorPage.js": [
		85951,
		951
	],
	"./spreadsheetai/SpreadsheetAIPage.js": [
		41771,
		771
	],
	"./taxagent/TaxAgentPage.js": [
		96509,
		509
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 25289;
module.exports = webpackAsyncContext;